import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Ctx = createContext(null);
const CLE_APERCU = "airthermo-apercu-theme";

export function chargerPolice(nom, poids = "400;500;600;700") {
  if (!nom || nom === "Système") return;
  const id = `police-${nom.replace(/\s+/g, "-")}`;
  if (document.getElementById(id)) return;
  const lien = document.createElement("link");
  lien.id = id;
  lien.rel = "stylesheet";
  lien.href = `https://fonts.googleapis.com/css2?family=${nom.trim().replace(/\s+/g, "+")}:wght@${poids}&display=swap`;
  document.head.appendChild(lien);
}

let clesAppliquees = [];

export function appliquerTheme(tokens = {}) {
  chargerPolice(tokens["font-nom"], tokens["font-poids"]);
  const root = document.documentElement;
  clesAppliquees.filter((k) => !(k in tokens)).forEach((k) => root.style.removeProperty(`--${k}`));
  clesAppliquees = Object.keys(tokens);
  Object.entries(tokens).forEach(([k, v]) => root.style.setProperty(`--${k}`, v));
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta && tokens.bg) meta.setAttribute("content", tokens.bg);
}

const lireApercu = () => {
  try { return JSON.parse(sessionStorage.getItem(CLE_APERCU)); } catch { return null; }
};

export function ThemeProvider({ children }) {
  const { user } = useAuth();
  const [actif, setActif] = useState(null);
  const [apercu, setApercu] = useState(lireApercu);

  const rechargerActif = useCallback(() => api.get("/themes/actif").then((r) => setActif(r.data)).catch(() => {}), []);
  useEffect(() => { rechargerActif(); }, [rechargerActif]);

  const quitterApercu = useCallback(() => { sessionStorage.removeItem(CLE_APERCU); setApercu(null); }, []);
  const demarrerApercu = (theme) => { sessionStorage.setItem(CLE_APERCU, JSON.stringify(theme)); setApercu(theme); };

  useEffect(() => { if (apercu && user !== null && user?.role !== "dirigeant") quitterApercu(); }, [user, apercu, quitterApercu]);
  useEffect(() => { const t = apercu || actif; if (t?.tokens) appliquerTheme(t.tokens); }, [apercu, actif]);
  const agencement = (apercu || actif)?.tokens?.agencement || "standard";
  useEffect(() => { document.documentElement.dataset.agencement = agencement; }, [agencement]);

  return <Ctx.Provider value={{ actif, apercu, demarrerApercu, quitterApercu, rechargerActif, agencement }}>{children}</Ctx.Provider>;
}

export const useTheme = () => useContext(Ctx);
export const useMessagerie = () => useContext(Ctx)?.agencement === "messagerie";
